import React, { useState } from 'react';
import { AlertCircle, Clock, TrendingDown, Search, Filter, ArrowRight, MoreVertical } from 'lucide-react';
export function OosTracker() {
  return <div className="space-y-6" data-id="element-719">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-720">
        <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm" data-id="element-721">
          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1" data-id="element-722">
            Current OOS Items
          </p>
          <p className="text-2xl font-black text-rose-600" data-id="element-723">8</p>
        </div>
        <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm" data-id="element-724">
          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1" data-id="element-725">
            Avg. OOS Duration
          </p>
          <p className="text-2xl font-black text-slate-900" data-id="element-726">2.4 Days</p>
        </div>
        <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm" data-id="element-727">
          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1" data-id="element-728">
            Est. Sales Loss
          </p>
          <p className="text-2xl font-black text-rose-600" data-id="element-729">$1,240</p>
        </div>
        <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm" data-id="element-730">
          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1" data-id="element-731">
            Most Impactful
          </p>
          <p className="text-sm font-black text-slate-900 truncate" data-id="element-732">
            Lobster Meat
          </p>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden" data-id="element-733">
        <div className="p-4 border-b border-slate-50 flex items-center justify-between" data-id="element-734">
          <div className="relative flex-1 max-w-md" data-id="element-735">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} data-id="element-736" />
            <input type="text" placeholder="Search OOS items..." className="w-full pl-10 pr-4 py-2 bg-slate-50 border-none rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" data-id="element-737" />
          </div>
          <div className="flex items-center gap-2" data-id="element-738">
            <button className="p-2 bg-white border border-slate-200 rounded-xl text-slate-600 hover:bg-slate-50 transition-all shadow-sm" data-id="element-739">
              <Filter size={18} data-id="element-740" />
            </button>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-741">
          <table className="w-full text-left border-collapse" data-id="element-742">
            <thead data-id="element-743">
              <tr className="bg-slate-50/50 border-b border-slate-100" data-id="element-744">
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-745">
                  Item
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-746">
                  OOS Date
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-747">
                  Duration
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-748">
                  Root Cause
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-749">
                  Status
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-right" data-id="element-750">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50" data-id="element-751">
              {[1, 2, 3].map(i => <tr key={i} className="hover:bg-slate-50/50 transition-colors group" data-id="element-752">
                  <td className="px-6 py-4" data-id="element-753">
                    <p className="text-sm font-bold text-slate-900" data-id="element-754">
                      Out of Stock Item {i}
                    </p>
                    <p className="text-[10px] text-slate-400 font-medium uppercase tracking-wider" data-id="element-755">
                      Food Master
                    </p>
                  </td>
                  <td className="px-6 py-4 text-sm font-medium text-slate-500" data-id="element-756">
                    Jan 10, 2025
                  </td>
                  <td className="px-6 py-4" data-id="element-757">
                    <span className="px-2 py-1 bg-rose-50 text-rose-600 text-[10px] font-black rounded uppercase border border-rose-100" data-id="element-758">
                      3 Days
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm font-medium text-slate-600" data-id="element-759">
                    Supplier Shortage
                  </td>
                  <td className="px-6 py-4" data-id="element-760">
                    <div className="flex items-center gap-1.5" data-id="element-761">
                      <div className="w-1.5 h-1.5 bg-amber-500 rounded-full" data-id="element-762" />
                      <span className="text-[10px] font-black text-amber-600 uppercase" data-id="element-763">
                        In Progress
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-764">
                    <button className="text-emerald-600 text-[10px] font-black hover:underline uppercase" data-id="element-765">
                      Update Plan
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}